import React, { useCallback } from 'react'
import formStyles from '../../../styles/forms.module.scss'
import styles from './EditorialEditor.module.scss'

export interface EditorialMetadata {
  title?: string
  body?: string
}

interface EditorialEditorProps {
  metadata: EditorialMetadata
  onChange: (metadata: EditorialMetadata) => void
}

const EditorialEditor: React.FC<EditorialEditorProps> = ({ metadata, onChange }) => {
  const update = useCallback(
    (patch: Partial<EditorialMetadata>) => onChange({ ...metadata, ...patch }),
    [metadata, onChange],
  )

  return (
    <>
      <div className={formStyles.fieldGroup}>
        <label>Title</label>
        <input
          type="text"
          value={metadata.title || ''}
          onChange={(e) => update({ title: e.target.value })}
          placeholder="Optional heading"
        />
      </div>

      <div className={formStyles.fieldGroup}>
        <label>Body</label>
        <textarea
          value={metadata.body || ''}
          onChange={(e) => update({ body: e.target.value })}
          placeholder="Markdown supported"
          rows={10}
          className={styles.bodyTextarea}
        />
        <p className={styles.hint}>Markdown: **bold**, _italic_, [link](url), - list</p>
      </div>
    </>
  )
}

export default EditorialEditor
